import axios from 'axios'

document.addEventListener('turbo:load', async () => {
  const showcaseEditorIframe = document.querySelector('#showcase.editor')
  if (showcaseEditorIframe) {
    const closeButton = document.getElementById('showcase-editor-save-button')
    closeButton.addEventListener('click', async () => {
      const showcaseEditorData = document.getElementById('dpm-showcase-editor').__vue__.dpmStore.SED
      const csrfHeader = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
      }
      const res = await axios.patch(
        `${data.apiUrl}/save_showcase_editor_data`,
        { showcase_editor_data: showcaseEditorData },
        { headers: csrfHeader }
      )
      if (res.data.location) {
        window.location.href = res.data.location
      }
    })

    const data = showcaseEditorIframe.dataset
    const DPM = new DriftPhotoModule(data.sid, { ...data, ...{
      bgm: { autoPlay: false, url: data.bgmUrl },
      showShowcaseEditor: true,
      urlParams: JSON.stringify({ play: 1, qs: 1 }),
      applicationKey: document.querySelector('meta[name="application-key"]').content
    } } )
    await DPM.load()
  }
})
